import React from 'react';
import Icon from '../../../components/AppIcon';

const NetworkStatistics = ({ statistics }) => {
  const statCards = [
    {
      id: 1,
      label: 'Total Red',
      value: statistics?.totalNetwork,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+12%',
      changeType: 'positive'
    },
    {
      id: 2,
      label: 'Nivel 1 (10%)',
      value: statistics?.level1Count,
      icon: 'UserPlus',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      commission: `S/ ${statistics?.level1Commission?.toLocaleString('es-PE', { minimumFractionDigits: 2 })}`
    },
    {
      id: 3,
      label: 'Nivel 2 (4%)',
      value: statistics?.level2Count,
      icon: 'Users2',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      commission: `S/ ${statistics?.level2Commission?.toLocaleString('es-PE', { minimumFractionDigits: 2 })}`
    },
    {
      id: 4,
      label: 'Nivel 3 (0.6%)',
      value: statistics?.level3Count,
      icon: 'UsersRound',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      commission: `S/ ${statistics?.level3Commission?.toLocaleString('es-PE', { minimumFractionDigits: 2 })}`
    },
    {
      id: 5,
      label: 'Nivel 4 (0.4%)',
      value: statistics?.level4Count,
      icon: 'Network',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      commission: `S/ ${statistics?.level4Commission?.toLocaleString('es-PE', { minimumFractionDigits: 2 })}`
    },
    {
      id: 6,
      label: 'Comisión Total Mes',
      value: `S/ ${statistics?.totalMonthlyCommission?.toLocaleString('es-PE', { minimumFractionDigits: 2 })}`,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+8.5%',
      changeType: 'positive'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
      {statCards?.map((stat) => (
        <div
          key={stat?.id}
          className="card p-4 md:p-5 lg:p-6 hover:elevation-3 transition-smooth"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            {stat?.change && (
              <div className={`
                flex items-center space-x-1 px-2 py-1 rounded-lg text-xs font-medium
                ${stat?.changeType === 'positive' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}
              `}>
                <Icon 
                  name={stat?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                />
                <span>{stat?.change}</span>
              </div>
            )}
          </div>

          <div>
            <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
            <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">
              {stat?.value}
            </p>
            {stat?.commission && (
              <p className="text-sm font-medium text-success">
                {stat?.commission}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NetworkStatistics;